(function () {
  // Prevent double-binding if this file is ever included twice
  if (window.__florabelleAddToCartBound) return;
  window.__florabelleAddToCartBound = true;

  let popupTimeout;

  /* ---------- Popup ---------- */

  function showPopup() {
    const popup = document.getElementById('cart-add-popup');
    if (!popup) return;

    // Don't show popup if already on cart page
    if (window.location.pathname === window.routes?.cart_url || window.location.pathname === '/cart') return;

    popup.classList.remove('hidden');
    clearTimeout(popupTimeout);
    popupTimeout = setTimeout(hidePopup, 15000); // auto-hide after 15s
  }

  function hidePopup() {
    const popup = document.getElementById('cart-add-popup');
    if (popup) popup.classList.add('hidden');
  }

  // Close / continue buttons (delegated so they work whenever the popup exists)
  document.addEventListener('click', function (e) {
    if (e.target.closest('#cart-add-popup-close, #cart-add-popup-continue')) hidePopup();
  });

  /* ---------- Helpers ---------- */

  function setButtonText(button, text) {
    if (!button) return;
    const span = button.querySelector('span');
    if (span) span.textContent = text;
    else if (button.tagName === 'INPUT') button.value = text;
    else button.textContent = text;
  }

  function getButtonText(button) {
    if (!button) return null;
    const span = button.querySelector('span');
    if (span) return span.textContent;
    return button.tagName === 'INPUT' ? button.value : button.textContent;
  }

  function updateCartIconBubble(sectionsData) {
    const cartIconElement = document.getElementById('cart-icon-bubble');
    if (!cartIconElement) return;

    let iconHtml = null;
    if (sectionsData && typeof sectionsData === 'object') iconHtml = sectionsData['cart-icon-bubble'];
    else if (typeof sectionsData === 'string') iconHtml = sectionsData;
    if (!iconHtml) return;

    const doc = new DOMParser().parseFromString(iconHtml, 'text/html');
    const sectionElement =
      doc.querySelector('.shopify-section') ||
      doc.querySelector('#shopify-section-cart-icon-bubble') ||
      doc.querySelector('[id*="cart-icon-bubble"]');

    if (!sectionElement) {
      const bodyContent = doc.body.innerHTML.trim();
      if (bodyContent) cartIconElement.innerHTML = bodyContent;
      return;
    }

    let content = sectionElement.innerHTML;

    // Keep custom header styling (harmless once cart-icon-bubble.liquid is updated)
    if (document.querySelector('.custom-header-a')) {
      const tempDiv = document.createElement('div');
      tempDiv.innerHTML = content;

      const bubble = tempDiv.querySelector('.cart-count-bubble');
      if (bubble) {
        const count = bubble.querySelector('span[aria-hidden="true"]')?.textContent || '';
        const hidden = bubble.querySelector('.visually-hidden')?.textContent || '';
        const customDiv = document.createElement('div');
        customDiv.style.textDecoration = 'none';
        customDiv.innerHTML = `<span aria-hidden="true">${count}</span><span class="visually-hidden">${hidden}</span>`;
        bubble.replaceWith(customDiv);
      }

      const currentIcon = document.querySelector('#cart-icon-bubble .svg-wrapper');
      const newIcon = tempDiv.querySelector('.svg-wrapper');
      if (currentIcon && newIcon) newIcon.innerHTML = currentIcon.innerHTML;

      content = tempDiv.innerHTML;
    }

    cartIconElement.innerHTML = content;
  }

  function animateCartIcon() {
    const cartIcon = document.getElementById('cart-icon-bubble');
    if (!cartIcon) return;
    cartIcon.classList.add('cart-icon-animate');
    setTimeout(() => cartIcon.classList.remove('cart-icon-animate'), 1500);
  }

  /* ---------- Add to cart (delegated: works for cards added by filters) ---------- */

  document.addEventListener('submit', function (e) {
    const form = e.target;
    if (!(form instanceof HTMLFormElement)) return;
    if (!/\/cart\/add\b/.test(form.getAttribute('action') || '')) return;

    // Another script (e.g. Dawn's product-form) already handled this submit
    if (e.defaultPrevented) return;

    e.preventDefault(); // stop normal form submission → no redirect to /cart

    // Ignore double clicks while a request is in progress
    if (form.dataset.adding === 'true') return;
    form.dataset.adding = 'true';

    const submitButton =
      e.submitter || form.querySelector('button[type="submit"], input[type="submit"]');
    const originalButtonText = getButtonText(submitButton);
    setButtonText(submitButton, 'Adding');

    const cartDrawer = document.querySelector('cart-drawer');
    const formData = new FormData(form);
    if (cartDrawer) formData.append('sections', 'cart-drawer');
    formData.append('sections', 'cart-icon-bubble');
    formData.append('sections_url', window.location.pathname);

    fetch('/cart/add.js', {
      method: 'POST',
      body: formData,
      headers: { Accept: 'application/json' },
    })
      .then(async (response) => {
        const data = await response.json();
        // Shopify returns 422 with { status, description } for stock / quantity errors
        if (!response.ok || data.status) throw data;
        return data;
      })
      .then((data) => {
        if (cartDrawer && data.sections) {
          cartDrawer.renderContents({ id: data.id, sections: data.sections });
        }

        if (data.sections && data.sections['cart-icon-bubble']) {
          updateCartIconBubble(data.sections);
        } else {
          fetch(`${window.routes.cart_url}?section_id=cart-icon-bubble`)
            .then((r) => r.text())
            .then(updateCartIconBubble)
            .catch((err) => console.error('Error updating cart icon:', err));
        }

        animateCartIcon();
        showPopup();
        document.dispatchEvent(new CustomEvent('cart:itemAdded', { detail: data }));

        setButtonText(submitButton, 'Added');
      })
      .catch((error) => {
        console.error('Error adding to cart:', error);

        // Show Shopify's message (e.g. "only 179 in stock") briefly, then restore
        if (error && error.description) {
          setButtonText(submitButton, error.description);
          setTimeout(() => setButtonText(submitButton, originalButtonText), 4000);
        } else {
          setButtonText(submitButton, originalButtonText);
        }
      })
      .finally(() => {
        delete form.dataset.adding;
      });
  });
})();